/* TESS SHOP — scripts propios (prefijo mt-). Un archivo, vanilla JS. */

document.addEventListener("DOMContentLoaded", function () {
  initReveal();
  initCifras();
  initGaleriaProducto();
  initSelectorVariantes();
});

function prefiereReducirMovimiento() {
  return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}

/* Revela con .mt-visible cualquier .mt-reveal cuando entra en pantalla */
function initReveal() {
  var elementos = document.querySelectorAll(".mt-reveal");
  if (!elementos.length) return;

  if (prefiereReducirMovimiento() || !("IntersectionObserver" in window)) {
    elementos.forEach(function (el) {
      el.classList.add("mt-visible");
    });
    return;
  }

  var observador = new IntersectionObserver(
    function (entradas) {
      entradas.forEach(function (entrada) {
        if (entrada.isIntersecting) {
          entrada.target.classList.add("mt-visible");
          observador.unobserve(entrada.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: "0px 0px -60px 0px" }
  );

  elementos.forEach(function (el, i) {
    el.style.setProperty("--mt-delay", i % 6);
    observador.observe(el);
  });
}

/* Cuenta hacia arriba cifras con [data-mt-cifra-hasta] al entrar en pantalla */
function initCifras() {
  var cifras = document.querySelectorAll("[data-mt-cifra-hasta]");
  if (!cifras.length) return;

  function animar(el) {
    var hasta = parseFloat(el.getAttribute("data-mt-cifra-hasta")) || 0;
    var decimales = (el.getAttribute("data-mt-cifra-hasta").split(".")[1] || "").length;
    if (prefiereReducirMovimiento()) {
      el.textContent = hasta.toFixed(decimales);
      return;
    }
    var duracion = 1400;
    var inicio = null;
    function paso(marca) {
      if (inicio === null) inicio = marca;
      var progreso = Math.min((marca - inicio) / duracion, 1);
      var valor = hasta * (1 - Math.pow(1 - progreso, 3));
      el.textContent = valor.toFixed(decimales);
      if (progreso < 1) window.requestAnimationFrame(paso);
    }
    window.requestAnimationFrame(paso);
  }

  if (!("IntersectionObserver" in window)) {
    cifras.forEach(animar);
    return;
  }
  var observador = new IntersectionObserver(
    function (entradas) {
      entradas.forEach(function (entrada) {
        if (entrada.isIntersecting) {
          animar(entrada.target);
          observador.unobserve(entrada.target);
        }
      });
    },
    { threshold: 0.4 }
  );
  cifras.forEach(function (el) {
    observador.observe(el);
  });
}

/* Galeria de la pagina de producto: clic en miniatura cambia la imagen principal */
function initGaleriaProducto() {
  var principal = document.querySelector("[data-mt-galeria-principal]");
  var miniaturas = document.querySelectorAll("[data-mt-galeria-miniatura]");
  if (!principal || !miniaturas.length) return;

  miniaturas.forEach(function (mini) {
    mini.addEventListener("click", function () {
      var full = mini.getAttribute("data-mt-galeria-miniatura");
      if (!full) return;
      principal.src = full;
      miniaturas.forEach(function (m) {
        m.classList.remove("mt-miniatura-activa");
      });
      mini.classList.add("mt-miniatura-activa");
    });
  });
}

/* Selector de variantes en la pagina de producto */
function initSelectorVariantes() {
  var contenedor = document.querySelector("[data-mt-producto]");
  if (!contenedor) return;

  var datosScript = contenedor.querySelector("[data-mt-variantes-json]");
  var inputId = contenedor.querySelector("[data-mt-input-variante-id]");
  var precioEl = contenedor.querySelector("[data-mt-precio]");
  var precioCompareEl = contenedor.querySelector("[data-mt-precio-comparado]");
  var botonComprar = contenedor.querySelector("[data-mt-boton-comprar]");
  var selects = contenedor.querySelectorAll("[data-mt-opcion]");
  if (!datosScript || !inputId || !selects.length) return;

  var variantes;
  try {
    variantes = JSON.parse(datosScript.textContent);
  } catch (e) {
    return;
  }

  function opcionesSeleccionadas() {
    var vals = [];
    selects.forEach(function (s) {
      vals.push(s.value);
    });
    return vals;
  }

  function actualizar() {
    var seleccion = opcionesSeleccionadas();
    var variante = variantes.find(function (v) {
      return v.options.every(function (op, i) {
        return op === seleccion[i];
      });
    });
    if (!variante) return;

    inputId.value = variante.id;

    if (variante.featured_image) {
      var principal = document.querySelector("[data-mt-galeria-principal]");
      if (principal && principal.src !== variante.featured_image) {
        principal.src = variante.featured_image;
      }
      var miniaturas = document.querySelectorAll("[data-mt-galeria-miniatura]");
      miniaturas.forEach(function (mini) {
        var coincide = mini.getAttribute("data-mt-galeria-miniatura") === variante.featured_image;
        mini.classList.toggle("mt-miniatura-activa", coincide);
        mini.style.borderColor = coincide ? "var(--mt-color-acento)" : "var(--mt-color-borde)";
      });
    }

    if (precioEl) precioEl.textContent = variante.price_formatted;
    if (precioCompareEl) {
      if (variante.compare_at_price_formatted) {
        precioCompareEl.textContent = variante.compare_at_price_formatted;
        precioCompareEl.style.display = "";
      } else {
        precioCompareEl.style.display = "none";
      }
    }
    if (botonComprar) {
      if (variante.available) {
        botonComprar.disabled = false;
        botonComprar.textContent = botonComprar.getAttribute("data-mt-texto-disponible") || botonComprar.textContent;
      } else {
        botonComprar.disabled = true;
        botonComprar.textContent = botonComprar.getAttribute("data-mt-texto-agotado") || "Agotado";
      }
    }
  }

  selects.forEach(function (s) {
    s.addEventListener("change", actualizar);
  });
  actualizar();
}
